import {
  ContactsOutlined,
  DashboardOutlined,
  SendOutlined,
} from '@ant-design/icons';

const pages = {
  id: 'group-communications',
  title: 'Communications',
  type: 'group',
  children: [
    {
      id: 'comms-overview',
      title: 'Comms Overview',
      type: 'item',
      url: '/communications/overview',
      icon: DashboardOutlined
    },
    {
      id: 'comms-compose',
      title: 'Compose Message',
      type: 'item',
      url: '/communications/compose',
      icon: SendOutlined
    },
    /*
    {
      id: 'comms-whatsapp',
      title: 'WhatsApp',
      type: 'collapse',
      icon: SendOutlined,
      children: [
        {
          id: 'comms-whatsapp-numbers',
          title: 'Manage Numbers',
          type: 'item',
          url: '/communications/whatsapp/numbers',
          breadcrumbs: false
        },
        {
          id: 'comms-whatsapp-from-file',
          title: 'Send from File',
          type: 'item',
          url: '/communications/whatsapp/from-file',
          breadcrumbs: false
        },
        {
          id: 'comms-whatsapp-ward',
          title: 'Send by Ward',
          type: 'item',
          url: '/communications/whatsapp/ward-database',
          breadcrumbs: false
        }
      ]
    },
    */
    {
      id: 'communications-contacts',
      title: 'Mhesh Contacts',
      type: 'item',
      url: '/communications/contacts',
      icon: ContactsOutlined,
      breadcrumbs: false
    }
  ]
};

export default pages;
